<div class="modal-backdrop" [mat-dialog-close]="true"></div>
<div class="modal-container scheduler">
  <button type="button" class="close" mat-dialog-close aria-label="close">
    <mat-icon>close</mat-icon>
  </button>
  <iframe [src]="data.calendarUrl | safe: SecurityContext.RESOURCE_URL"></iframe>
</div>
